export default __webpack_public_path__ + "static/media/financials_icon.b503afe2.svg";